<template>
    <div class="space-y-4">
        <Loading v-if="loading" />
        <h3 class="text-2xl font-semibold leading-6 text-gray-900">
            Share Link
        </h3>

        <BaseCard padless>
            <nav class="flex rounded-t-lg border-b border-gray-200 bg-white">
                <button v-for="(tab, index) in tabs" :key="index" type="button"
                    class="max-w-xs flex-1 overflow-hidden border-r border-gray-200 py-4 px-4 text-center text-sm font-medium hover:bg-gray-50"
                    :class="tab === activeTab ? 'bg-gray-50 text-green-600' : 'text-gray-500'
                        " @click="onChangeTab(tab)">
                    <span>{{ tab }}</span>
                </button>
            </nav>

            <div class="px-4 py-5 sm:p-6">
                <Datatable :columns="headers" :total="shareLinks.meta.page.total"
                    :perPage="shareLinks.meta.page.perPage" :currentPage="shareLinks.meta.page.currentPage"
                    @pagechanged="onChangePage">
                    <template #tbody="{ classes }">
                        <tr v-for="shareLink in shareLinks.data" :key="shareLink.id" :class="classes.tr">
                            <td :class="classes.td">{{ shareLink.attributes.createdAt | formatDate }}</td>
                            <td :class="classes.td">{{ shareLink.attributes.link_url ?? '-' }}</td>
                            <td :class="classes.td">{{ shareLink.attributes.visit_count | toCurrency }}</td>
                        </tr>
                    </template>
                </Datatable>
            </div>
        </BaseCard>
    </div>
</template>

<script>
import { requestMixin } from '../../mixins/request/request';

export default {
    mixins: [requestMixin],
    data() {
        return {
            loading: true,
            tabs: ['Produk', 'Order', 'Paket'],
            activeTab: 'Produk',
            shareLinks: {
                meta: {
                    page: {}
                },
                data: []
            }
        };
    },
    computed: {
        headers() {
            return [
                {
                    id: 'createdAt',
                    name: 'Tanggal'
                },
                {
                    id: 'link',
                    name: 'Link'
                },
                {
                    id: 'visit',
                    name: 'Kunjungan'
                }
            ]
        }
    },
    methods: {
        async loadShareLinks(params) {
            this.loading = true

            const [res, err] = await this.request(`/api/v1/share-links`, {
                params: {
                    'page[size]': 5,
                    'filter[link_type]': {
                        'Produk': 'multi_product_link',
                        'Order': 'order',
                        'Paket': 'packet_product'
                    }[this.activeTab],
                    ...params
                }
            })

            if (!err) {
                this.shareLinks = res
            }

            this.loading = false
        },
        onChangeTab(tab) {
            this.activeTab = tab;

            this.loadShareLinks()
        },
        onChangePage(page) {
            this.loadShareLinks({
                'page[number]': page
            })
        }
    },
    created() {
        this.loadShareLinks()
    }
};
</script>
